"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.analytics = void 0;
var _constantsGenerated = require("../constants-generated");
var _getSearchTime = require("./getSearchTime");
const analytics = exports.analytics = {
  formatProduct: ({
    name,
    brand,
    code,
    image,
    price,
    category,
    currencyCode
  }) => ({
    currency: currencyCode,
    globalBrandName: '',
    globalCategoryName: '',
    globalName: '',
    itemCode: code,
    localBrandName: brand ?? '',
    localCategoryName: category ?? '',
    localName: name,
    media: image ? [image] : [],
    price: price?.price
  }),
  getSignalsData: ({
    customerId,
    position,
    results,
    timestamp,
    query,
    sessionId,
    type = 'click',
    code
  }) => ({
    params: {
      count: 1,
      docId: code ?? results.products[position]?.code,
      filterQueries: ['products'],
      position: position + 1,
      query,
      searchTime: (0, _getSearchTime.getSearchTime)(timestamp),
      source: _constantsGenerated.PACKAGE_NAME,
      totalHits: results.numberOfProducts,
      userId: customerId.toString(),
      sessionId
    },
    timeStamp: new Date(),
    type
  })
};